(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[148],{

/***/ "+nt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/components/lines/highlight-line/HighlightLine.jsx

var __jsx = react_default.a.createElement;


var HighlightLine_HighlightLine = function HighlightLine(props) {
  return __jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    className: "Line Line-Highlight",
    hLevel: 2,
    size: props.size === 'small' ? 'highlightSmall' : 'highlight',
    trackingData: {
      actionGA: 'highlight'
    }
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/highlight/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (HighlightLine_HighlightLine);

/***/ }),

/***/ "2B1m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hero; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("KqXw");
/* harmony import */ var core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Ysgh");
/* harmony import */ var core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("tVqn");
/* harmony import */ var core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_trim__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("hBvt");
/* harmony import */ var core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("zjfJ");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("MwrP");
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("C/y5");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("UCZK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("1JJ2");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("sRdV");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("mmhe");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("i5Mr");
/* harmony import */ var _frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("3jv5");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("qqKu");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("zwLB");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("Bkb1");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("829J");
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("EkOT");
/* harmony import */ var _tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("DqI1");
/* harmony import */ var _heroUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("5xkM");













var __jsx = react__WEBPACK_IMPORTED_MODULE_13___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react/no-danger */
















var Hero = function Hero(_ref) {
  var alt = _ref.alt,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_20__[/* default */ "a"] : _ref$as,
      _ref$backgroundURLDes = _ref.backgroundURLDesktop,
      backgroundURLDesktop = _ref$backgroundURLDes === void 0 ? '' : _ref$backgroundURLDes,
      _ref$backgroundURLMob = _ref.backgroundURLMobile,
      backgroundURLMobile = _ref$backgroundURLMob === void 0 ? '' : _ref$backgroundURLMob,
      className = _ref.className,
      contentPosition = _ref.contentPosition,
      countdown = _ref.countdown,
      hasOverlap = _ref.hasOverlap,
      _ref$hLevel = _ref.hLevel,
      hLevel = _ref$hLevel === void 0 ? 1 : _ref$hLevel,
      link = _ref.link,
      icon = _ref.icon,
      id = _ref.id,
      _ref$isImmersive = _ref.isImmersive,
      isImmersive = _ref$isImmersive === void 0 ? false : _ref$isImmersive,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      style = _ref.style,
      subtitle = _ref.subtitle,
      _ref$theming = _ref.theming,
      theming = _ref$theming === void 0 ? {} : _ref$theming,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      trackingData = _ref.trackingData,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url;
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_17__[/* useTracking */ "a"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_16__[/* useResponsive */ "b"])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var _useRouter = Object(next_router__WEBPACK_IMPORTED_MODULE_24__["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useTrackEvent = Object(_tracking_tracking_api_useTrackEvent__WEBPACK_IMPORTED_MODULE_27__[/* useTrackEvent */ "a"])(),
      trackEvent = _useTrackEvent.trackEvent;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_26__[/* usePageContext */ "b"])(),
      siteSection = _usePageContext.siteSection; // just in case, you know, someone forgets to set one or something
  // mobile is default because Mobile First™
  // we're keeping the support for the legacy url prop for backwards compat
  // i.e. with ImmersiveSlideshow, as providing only a desktop url or a mobile one is pretty awkward


  var _generateBackgroundSt = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* generateBackgroundStylesAndClassName */ "d"])({
    backgroundURLDesktop: backgroundURLDesktop || url,
    backgroundURLMobile: backgroundURLMobile || url
  }),
      styleTag = _generateBackgroundSt.style,
      imageClassName = _generateBackgroundSt.className;

  var _theming$titleColor = theming.titleColor,
      titleColor = _theming$titleColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$titleColor,
      _theming$subtitleColo = theming.subtitleColor,
      subtitleColor = _theming$subtitleColo === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$subtitleColo,
      _theming$countdownCol = theming.countdownColor,
      countdownColor = _theming$countdownCol === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE : _theming$countdownCol,
      _theming$linkColor = theming.linkColor,
      linkColor = _theming$linkColor === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].BLACK : _theming$linkColor,
      _theming$linkBackgrou = theming.linkBackgroundColor,
      linkBackgroundColor = _theming$linkBackgrou === void 0 ? _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].SAFFRON : _theming$linkBackgrou;

  var _getHeroDimensions = Object(_heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* getHeroDimensions */ "e"])(size),
      heightClassName = _getHeroDimensions.heightClassName,
      paddingBottomClassName = _getHeroDimensions.paddingBottomClassName,
      paddingTopClassName = _getHeroDimensions.paddingTopClassName;

  var isHighlight = size === 'highlightSmall' || size === 'highlight';
  var textAlignment = contentPosition ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"][contentPosition] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* TITLE_POSITIONS */ "c"]['bottom-left'];
  var horizontalAlignment = contentPosition ? contentPosition.split('-')[1] : '';
  var linkSpacing = horizontalAlignment ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* LINK_SPACINGS */ "b"][horizontalAlignment] : '';

  var tracking = _objectSpread({
    actionGA: 'immersive',
    labelGA: "".concat(title).trim()
  }, trackingData);

  var TitleAndSubtitleWrapperTag = (link === null || link === void 0 ? void 0 : link.url) ? as : react__WEBPACK_IMPORTED_MODULE_13__["Fragment"];
  var titleAndSubtitleWrapperProps = (link === null || link === void 0 ? void 0 : link.url) ? {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('inline-block transform transition-all duration-250 ease-in hover:scale-105', linkSpacing),
    'data-testid': isImmersive ? 'immersive-text' : undefined,
    onClick: function onClick() {
      return track(tracking);
    },
    url: link.url
  } : {};

  var getTitleAndSubtitleWrapperProps = function getTitleAndSubtitleWrapperProps() {
    if (!(link === null || link === void 0 ? void 0 : link.url)) {
      return;
    }

    if (as === 'a') {
      return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
        href: link === null || link === void 0 ? void 0 : link.url
      });
    }

    return _objectSpread(_objectSpread({}, titleAndSubtitleWrapperProps), {}, {
      url: link === null || link === void 0 ? void 0 : link.url
    });
  };

  var buttonTrack = function buttonTrack(trackingPayload) {
    var isPBFLanding = Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_23__[/* isPBFLandingPage */ "m"])(asPath);

    if (siteSection === 'Shopping_Landing' && isPBFLanding) {
      trackEvent(_tracking_constants__WEBPACK_IMPORTED_MODULE_25__[/* TRACK_EVENT_NAMES */ "F"].CLICK_PREBOOKING_FORM_PREREG, {
        detail_click: 'check_my_request'
      });
    } else {
      track && track(trackingPayload);
    }
  };

  var displayIcon = isDesktop ? icon === null || icon === void 0 ? void 0 : icon.displayDesktop : icon === null || icon === void 0 ? void 0 : icon.displayMobile;
  var iconLink = (isTablet ? icon === null || icon === void 0 ? void 0 : icon.linkDesktop : icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkMobile) || (icon === null || icon === void 0 ? void 0 : icon.linkDesktop); // hey isn't that the same logic that we used up there for the imageUrl?
  // yes it is!

  return __jsx("div", {
    "aria-label": alt,
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(heightClassName, className),
    "data-size": size,
    "data-testid": "Hero",
    id: id,
    role: "img",
    style: style
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('relative', heightClassName, paddingTopClassName)
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('animation-duration-500 absolute inset-x-0 top-0 h-full w-full animate-fadeIn bg-cover bg-center bg-no-repeat', imageClassName, heightClassName)
  }), icon && displayIcon && iconLink && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingTopClassName, 'absolute inset-0', {
      'pb-40': hasOverlap
    })
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('m-auto flex h-full w-full max-w-site overflow-hidden p-20', isTablet ? _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionDesktop] : _heroUtils__WEBPACK_IMPORTED_MODULE_28__[/* ICON_POSITIONS */ "a"][icon.positionMobile]),
    dir: "ltr"
  }, __jsx("img", {
    alt: icon.alt || '',
    className: "max-h-full flex-none",
    src: iconLink,
    style: {
      width: isTablet ? "calc(".concat(icon.desktopWidth, " / 1180 * 100vw)") : "calc(".concat(icon.mobileWidth, " / 375 * 100vw)"),
      maxWidth: isTablet ? icon.desktopWidth : icon.mobileWidth
    }
  }))), !!title && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])(paddingBottomClassName, 'relative z-1 flex h-full flex-col px-20 pt-10 align-bottom')
  }, __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("mx-auto flex w-full max-w-site flex-col ".concat(textAlignment))
  }, __jsx(TitleAndSubtitleWrapperTag, getTitleAndSubtitleWrapperProps(), __jsx(_frameworks_heading_Heading__WEBPACK_IMPORTED_MODULE_21__[/* Heading */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])("text-".concat(titleColor), {
      'lg:text-48': !isHighlight && size !== 'small',
      'text-shadow-3': titleColor === _utils_color_colors__WEBPACK_IMPORTED_MODULE_15__[/* COLORS */ "a"].WHITE
    }),
    hLevel: hLevel,
    theme: "heading-brand-1"
  }, title), !!subtitle && __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_22__[/* Text */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-5 font-bold text-shadow-3 md:text-16', "text-".concat(subtitleColor)),
    text: subtitle,
    theme: "text-sans-n1"
  })), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_12___default()(countdown) && __jsx(_frameworks_countdown_Countdown__WEBPACK_IMPORTED_MODULE_19__[/* Countdown */ "a"], {
    className: "py-10",
    color: countdownColor,
    dateTimeEnd: countdown.dateTimeEnd,
    days: countdown.days,
    hours: countdown.hours,
    minutes: countdown.minutes,
    seconds: countdown.seconds
  }), (link === null || link === void 0 ? void 0 : link.label) && __jsx("div", {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])({
      'mt-auto': isHighlight
    })
  }, __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_18__[/* Button */ "a"], {
    className: Object(_utils_classnames_classnames_utils__WEBPACK_IMPORTED_MODULE_14__[/* classnames */ "a"])('mt-15 md:mt-0', {
      'w-full': !isDesktop
    }, isHighlight && !isDesktop ? 'max-w-none' : 'max-w-280'),
    color: linkColor,
    colorBg: linkBackgroundColor,
    "data-testid": isImmersive ? 'immersive-button' : undefined,
    isExternalLink: isImmersive,
    onClick: function onClick() {
      return buttonTrack(tracking);
    },
    url: link.url || '#hero-beacon'
  }, link.label)))), __jsx("style", {
    dangerouslySetInnerHTML: {
      __html: styleTag
    }
  }), title && __jsx("div", {
    className: "absolute inset-0 bg-[linear-gradient(to_bottom,rgba(0,0,0,0)_0%,rgba(0,0,0,0.2)_100%)]"
  })), __jsx("div", {
    id: "hero-beacon"
  }));
};

/***/ }),

/***/ "3jv5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Heading_Heading; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/react-markdown/lib/react-markdown.js
var react_markdown = __webpack_require__("VqYj");
var react_markdown_default = /*#__PURE__*/__webpack_require__.n(react_markdown);

// EXTERNAL MODULE: /opt/webapp/node_modules/remark-breaks/index.js
var remark_breaks = __webpack_require__("l24s");
var remark_breaks_default = /*#__PURE__*/__webpack_require__.n(remark_breaks);

// EXTERNAL MODULE: ./src/client/components/utils/markdown/markdown.js
var markdown = __webpack_require__("ZMpj");

// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.themes.js
var themes = {
  none: {
    thRoot: ''
  },
  'heading-brand-1': {
    thRoot: 'text-black font-brand text-32 leading-tight'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/heading/Heading.jsx









var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var MARKDOWN_ALLOWED_TYPES = [markdown["a" /* HTML_ELEMENTS */].BREAK.type, markdown["a" /* HTML_ELEMENTS */].EMPHASIS.type, markdown["a" /* HTML_ELEMENTS */].PARAGRAPH.type, markdown["a" /* HTML_ELEMENTS */].STRONG.type, markdown["a" /* HTML_ELEMENTS */].TEXT.type];

var HeadingText = function HeadingText(_ref) {
  var children = _ref.children;
  return children;
};

var Heading_Heading = function Heading(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$hLevel = _ref2.hLevel,
      hLevel = _ref2$hLevel === void 0 ? 1 : _ref2$hLevel,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? 'heading-brand-1' : _ref2$theme,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref2, ["children", "className", "hLevel", "theme"]);

  if (!react["Children"].count(children)) {
    return null;
  }

  var thRoot = themes[theme].thRoot;
  return __jsx(react_markdown_default.a, {
    allowedTypes: MARKDOWN_ALLOWED_TYPES,
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className),
    plugins: [remark_breaks_default.a],
    renderers: {
      root: Object(markdown["c" /* markdownRootHeadingRenderer */])(_objectSpread(_objectSpread({}, rest), {}, {
        hLevel: hLevel
      })),
      paragraph: HeadingText
    }
  }, children);
};

/***/ }),

/***/ "5xkM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LINK_SPACINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TITLE_POSITIONS; });
/* unused harmony export SIZES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHeroDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateBackgroundStylesAndClassName; });
/* unused harmony export getBackgroundImageUrl */
/* unused harmony export getBackgroundRule */
/* unused harmony export getAllBackgroundRules */
/* unused harmony export AUTO */
/* unused harmony export PREFIXES */
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("KOtZ");
/* harmony import */ var core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reduce__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("daRM");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("FtHn");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("+KXO");
/* harmony import */ var core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("zjfJ");
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("FLQK");
/* harmony import */ var _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("lDxO");
/* harmony import */ var _utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("m1JM");











function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}




var AUTO = '_AUTOFORMAT_';
var PREFIXES = ['webkit', 'moz', 'o', 'ms'];

var getBackgroundImageUrl = function getBackgroundImageUrl(url, width) {
  var options = {
    format: AUTO,
    url: url,
    width: width,
    height: 'auto',
    transform: 'resize',
    quality: 70
  };
  return _utils_media_server__WEBPACK_IMPORTED_MODULE_10__[/* getUrl */ "a"](options);
};

var getBackgroundRule = function getBackgroundRule(params) {
  return function (getUrlFunction) {
    return function (prefixes) {
      var id = params.id,
          url = params.url,
          width1x = params.width1x,
          width2x = params.width2x;
      return ".".concat(id, " {\n        background-image:url(").concat(getUrlFunction(url, width1x), ");\n        ").concat(prefixes.reduce(function (acc, prefix) {
        return "".concat(acc, "\n        background-image: -").concat(prefix, "-image-set(url(").concat(getUrlFunction(url, width1x), ") 1x, url(").concat(getUrlFunction(url, width2x), ") 2x);\n        ");
      }, ''), "\n      }");
    };
  };
};

var getAllBackgroundRules = function getAllBackgroundRules(params) {
  return function (getRuleFunction) {
    return "".concat(getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES));
  };
};

var ICON_POSITIONS = {
  'top-left': 'items-start justify-start',
  'top-middle': 'items-start justify-center',
  'top-right': 'items-start justify-end',
  'center-left': 'items-center justify-start',
  'center-middle': 'items-center justify-center',
  'center-right': 'items-center justify-end',
  'bottom-left': 'items-end justify-start',
  'bottom-middle': 'items-end justify-center',
  'bottom-right': 'items-end justify-end'
};
var LINK_SPACINGS = {
  left: 'md:p-30 md:-ms-30',
  middle: 'md:p-30',
  right: 'md:p-30 md:-me-30'
};
var TITLE_POSITIONS = {
  'top-left': 'mb-auto items-start text-start',
  'top-middle': 'mb-auto items-center text-center',
  'top-right': 'mb-auto items-end text-end',
  'center-left': 'my-auto items-start text-start',
  'center-middle': 'my-auto items-center text-center',
  'center-right': 'my-auto items-end text-end',
  'bottom-left': 'mt-auto items-start text-start',
  'bottom-middle': 'mt-auto items-center text-center',
  'bottom-right': 'mt-auto items-end text-end'
};
var SIZES = {
  small: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  highlightSmall: {
    mobile: {
      height: '220px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '340px',
      paddingBottom: '80px'
    }
  },
  medium: {
    mobile: {
      height: '320px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '440px',
      paddingBottom: '100px'
    }
  },
  large: {
    mobile: {
      height: '420px',
      paddingBottom: '60px'
    },
    desktop: {
      height: '540px',
      paddingBottom: '115px'
    }
  },
  highlight: {
    mobile: {
      height: '480px',
      paddingBottom: '40px'
    },
    desktop: {
      height: '480px',
      paddingBottom: '70px'
    }
  },
  full: {
    mobile: {
      height: '100%',
      paddingBottom: '60px'
    },
    desktop: {
      height: '100%',
      paddingBottom: '115px'
    }
  }
};
var getHeroDimensions = function getHeroDimensions(sizeProp) {
  var isHighlight = sizeProp === 'highlightSmall' || sizeProp === 'highlight';
  return {
    heightClassName: "immersiveHeight--".concat(sizeProp),
    paddingBottomClassName: "immersivePaddingBottom--".concat(sizeProp),
    paddingTopClassName: isHighlight ? 'immersivePaddingTop--highlight' : 'immersivePaddingTop'
  };
};
var generateBackgroundStylesAndClassName = function generateBackgroundStylesAndClassName(_ref) {
  var backgroundURLDesktop = _ref.backgroundURLDesktop,
      backgroundURLMobile = _ref.backgroundURLMobile;

  if (!backgroundURLDesktop && !backgroundURLMobile) {
    return {
      style: '',
      className: ''
    };
  }

  var url = backgroundURLDesktop || backgroundURLMobile;
  var componentId = Object(_utils_unique_id_uniqueId__WEBPACK_IMPORTED_MODULE_12__[/* generateUniqueId */ "b"])([url]);
  var widths = _utils_media_server_dictionary__WEBPACK_IMPORTED_MODULE_11__[/* defaultDictionnary */ "a"].getWidthRanges();
  var params = {
    id: componentId,
    url: url
  };
  var mobileUrl = backgroundURLMobile || backgroundURLDesktop;
  return {
    className: componentId,
    style: "".concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[1],
      width2x: widths[2]
    }))(getBackgroundRule), "\n      @media all and (min-width: 22.51em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      url: mobileUrl,
      width1x: widths[2],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 40.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[3],
      width2x: widths[5]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 64.01em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[5],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }\n      @media all and (min-width: 76.26em) {\n        ").concat(getAllBackgroundRules(_objectSpread(_objectSpread({}, params), {}, {
      width1x: widths[6],
      width2x: widths[6]
    }))(getBackgroundRule), "\n      }")
  };
};


/***/ })

}]);